import React, { useEffect, Suspense } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { pages, pagesRedirect } from "src/components/routes";
import { SwitchMode, allPages, allowedPages } from "src/navigation";
import { makeHierarchicalPath } from "src/navigation/Link";
import { PAGES } from "src/types/navigation";
import { useRedirect } from "src/navigation/useRedirect";
import { useSelector } from "react-redux";
import { RootState } from "../store/index";

const AuthGate: React.FC<SwitchMode & { scheme: PAGES }> = ({
  mode,
  scheme,
}) => {
  const accessToken = useSelector((state: RootState) => state.auth.token);

  const { redirect } = useRedirect();

  useEffect(() => {
    if (
      accessToken &&
      mode === "guest" &&
      !allowedPages["authenticated"].includes(scheme)
    ) {
      redirect({ scheme: PAGES.ROOT });
    }

    if (
      !accessToken &&
      mode === "authenticated" &&
      !allowedPages["guest"].includes(scheme)
    ) {
      redirect({ scheme: PAGES.AUTH });
    }
  }, [accessToken, mode, redirect, scheme]);

  if (!allowedPages[mode].includes(scheme)) {
    const url = pagesRedirect[mode];
    const to = makeHierarchicalPath(
      undefined,
      Array.isArray(url) ? url : [url],
      "replace"
    );

    if (to) {
      return <Navigate replace to={to} />;
    }
  }

  const Component = pages[scheme].component;
  return (
    <Suspense fallback={<div>Загрузка...</div>}>
      <Component />;
    </Suspense>
  );
};

export const PagesSwitch: React.FC<SwitchMode> = ({ mode }) => {
  const location = useLocation();
  const { redirect } = useRedirect();

  useEffect(() => {
    if (location.pathname === "/") {
      redirect({
        scheme: PAGES.AUTH,
      });
    }
  }, []);

  return (
    <Routes
      location={{
        ...location,
        pathname: location.pathname.split("/~/")[0],
      }}
    >
      {allPages.map((scheme) => (
        <Route
          key={scheme}
          path={scheme}
          element={<AuthGate mode={mode} scheme={scheme} />}
        />
      ))}
    </Routes>
  );
};
